import { LocationData } from './Locations'

export const AdminLocations = {
  GettingStarted: '/getting-started',

  Dashboard: '/dashboard',
  DashboardLocation: '/dashboard/locations/:locationKey',
  DashboardProgram: '/dashboard/programs/:launchId',
  DashboardProgramData: '/dashboard/programs/:launchId/data',
  DashboardProgramConnections: '/dashboard/programs/:launchId/connections',
  DashboardProgramConnection:
    '/dashboard/programs/:launchId/connections/:merchantId',

  Analysis: '/analysis',

  Report: '/report',
  Reporting: '/reporting',

  ProviderCatalog: '/provider-catalog',

  Programs: {
    Overview: '/programs',
    Launch: '/launch-programs',
    Edit: '/launch-programs/edit',
    Success: '/launch-programs/success',
  },

  Flex: {
    Programs: '/flex',
    Overview: '/flex/:segmentId',
    Activation: '/flex/:segmentId/activation',
    Manage: '/flex/:segmentId/manage',
  },

  Micromobility: {
    Programs: '/micromobility',
    Overview: '/micromobility/:segmentId',
    Activation: '/micromobility/:segmentId/activation',
    Manage: '/micromobility/:segmentId/manage',
  },

  QTF: {
    Programs: '/tax-savings',
    Overview: '/tax-savings/:segmentId',
    Activation: '/tax-savings/:segmentId/activation',
    ActivationDefault: '/tax-savings/activation',
    /** ActivationOnboarding is a separate page because we can set path: null
     * in locationdata which prevents the user from navigating backwards using
     * the navigation  bar. This could be reinvestigated in the future.
     */
    ActivationOnboarding: '/tax-savings/activation/onboarding',
    Manage: '/tax-savings/:segmentId/manage',
  },

  GRH: {
    Programs: '/guaranteed-rides',
    Overview: '/guaranteed-rides/:segmentId',
    Activation: '/guaranteed-rides/:segmentId/activation',
    Manage: '/guaranteed-rides/:segmentId/manage',
  },

  OTP: {
    Programs: '/one-time-purchase',
    Overview: '/one-time-purchase/:segmentId',
    Activation: '/one-time-purchase/:segmentId/activation',
    Manage: '/one-time-purchase/:segmentId/manage',
  },

  Incentives: {
    Programs: '/trips',
    Trips: '/trips/:segmentId',
    Activation: '/trips/:segmentId/incentives/activation',
    Manage: '/trips/:segmentId/incentives/manage',
    OTRHistory: '/trips/:segmentId/incentives/otr-history',
  },

  OptIn: {
    Programs: '/opt-in',
    Overview: '/opt-in/:segmentId',
    QuestionOverview: '/opt-in/:segmentId/:questionId',
  },

  OTR: {
    OTRHistory: '/one-time-rewards',
  },

  Leaderboards: {
    Programs: '/leaderboards',
    Leaderboards: '/leaderboards/:segmentId',
    Activation: '/leaderboards/:segmentId/:leaderboardType/activation',
    Manage: '/leaderboards/:segmentId/:leaderboardType/manage',
  },

  Segments: {
    Overview: '/segments/overview',
    UploadHistory: '/segments/upload-history',
  },

  Concierge: {
    Concierge: '/concierge',
    Announcement: '/concierge/announcement',
    Faq: '/concierge/faq',
  },

  Accounts: {
    Profile: '/accounts/profile',
    Billing: '/accounts/billing',
  },

  ActivateCard: '/activate-card',

  ReimbursementSubmissions: '/reimbursement-submissions',
  ReimbursementDetails: '/reimbursement-submissions/:id',

  Compliance: '/compliance',
}

export const adminLocationData: Dictionary<LocationData> = {
  [AdminLocations.GettingStarted]: {
    title: '',
    head: 'Getting Started',
    ignoreMaxWidth: true,
    noPadding: true,
  },
  [AdminLocations.Dashboard]: {
    title: 'Dashboard',
    hasDate: true,
    ignoreMaxWidth: true,
    noPadding: true,
  },

  [AdminLocations.DashboardLocation]: {
    title: 'Location',
    ignoreMaxWidth: true,
    noPadding: true,
  },

  [AdminLocations.DashboardProgram]: {
    title: 'Program',
    ignoreMaxWidth: true,
    noPadding: true,
  },

  [AdminLocations.DashboardProgramData]: {
    title: 'Program data',
    ignoreMaxWidth: true,
    noPadding: true,
  },

  [AdminLocations.DashboardProgramConnections]: {
    title: 'Connections',
    ignoreMaxWidth: true,
    noPadding: true,
  },

  [AdminLocations.DashboardProgramConnection]: {
    title: 'Connection',
    ignoreMaxWidth: true,
    noPadding: true,
  },

  [AdminLocations.Analysis]: {
    title: 'Analysis',
    ignoreMaxWidth: true,
    noPadding: true,
  },

  [AdminLocations.Reporting]: {
    title: 'Reporting',
    ignoreMaxWidth: true,
  },

  [AdminLocations.Report]: {
    title: 'Report',
    ignoreMaxWidth: true,
  },

  [AdminLocations.Compliance]: {
    title: 'Compliance',
    analyticsTitle: 'compliance',
  },

  [AdminLocations.ProviderCatalog]: {
    title: 'Service Provider Catalog',
    showVerticalScroll: true,
  },

  //Flex
  [AdminLocations.Flex.Programs]: {
    title: 'Flex Programs',
    head: 'Flex',
    btnType: 'cta',
    btnVariant: 'primary',
    btnText: 'New Program',
    analyticsTitle: 'flex',
  },
  [AdminLocations.Flex.Overview]: {
    title: ':id',
    path: [AdminLocations.Flex.Programs, AdminLocations.Flex.Overview],
    hasDate: true,
    head: 'Flex',
    btnType: 'sidebar',
    btnVariant: 'secondary',
    btnText: 'All Programs',
    analyticsTitle: 'flex',
  },
  [AdminLocations.Flex.Activation]: {
    title: 'New Program',
    path: [
      AdminLocations.Flex.Programs,
      AdminLocations.Flex.Overview,
      AdminLocations.Flex.Activation,
    ],
    head: 'Flex',
  },
  [AdminLocations.Flex.Manage]: {
    title: 'Manage Program',
    path: [
      AdminLocations.Flex.Programs,
      AdminLocations.Flex.Overview,
      AdminLocations.Flex.Manage,
    ],
    head: 'Flex',
  },

  //GRH
  [AdminLocations.GRH.Programs]: {
    title: 'Guaranteed Ride Home Programs',
    head: 'Guaranteed Ride',
    btnType: 'cta',
    btnVariant: 'primary',
    btnText: 'New Program',
    analyticsTitle: 'grh',
  },
  [AdminLocations.GRH.Overview]: {
    title: ':id',
    path: [AdminLocations.GRH.Programs, AdminLocations.GRH.Overview],
    hasDate: true,
    head: 'Guaranteed Ride',
    btnType: 'sidebar',
    btnVariant: 'secondary',
    btnText: 'All Programs',
    analyticsTitle: 'grh',
  },
  [AdminLocations.GRH.Activation]: {
    title: 'New Program',
    path: [
      AdminLocations.GRH.Programs,
      AdminLocations.GRH.Overview,
      AdminLocations.GRH.Activation,
    ],
    head: 'Guaranteed Ride',
  },
  [AdminLocations.GRH.Manage]: {
    title: 'Manage Program',
    path: [
      AdminLocations.GRH.Programs,
      AdminLocations.GRH.Overview,
      AdminLocations.GRH.Manage,
    ],
    head: 'Guaranteed Ride',
  },

  //OTP
  [AdminLocations.OTP.Programs]: {
    title: 'One Time Purchase Programs',
    head: 'One Time Purchase',
    btnType: 'cta',
    btnVariant: 'primary',
    btnText: 'New Program',
    analyticsTitle: 'otp',
  },
  [AdminLocations.OTP.Overview]: {
    title: ':id',
    path: [AdminLocations.OTP.Programs, AdminLocations.OTP.Overview],
    hasDate: true,
    head: 'One Time Purchase',
    btnType: 'sidebar',
    btnVariant: 'secondary',
    btnText: 'All Programs',
    analyticsTitle: 'otp',
  },
  [AdminLocations.OTP.Activation]: {
    title: 'New Program',
    path: [
      AdminLocations.OTP.Programs,
      AdminLocations.OTP.Overview,
      AdminLocations.OTP.Activation,
    ],
    head: 'One Time Purchase',
  },
  [AdminLocations.OTP.Manage]: {
    title: 'Manage Program',
    path: [
      AdminLocations.OTP.Programs,
      AdminLocations.OTP.Overview,
      AdminLocations.OTP.Manage,
    ],
    head: 'One Time Purchase',
  },

  //QTF
  [AdminLocations.QTF.Programs]: {
    title: 'Pre-Tax Commuter Programs',
    head: 'Tax Savings',
    btnType: 'cta',
    btnVariant: 'primary',
    btnText: 'New Program',
    analyticsTitle: 'qtf',
  },
  [AdminLocations.QTF.Overview]: {
    title: ':id',
    path: [AdminLocations.QTF.Programs, AdminLocations.QTF.Overview],
    hasDate: true,
    head: 'Tax Savings',
    btnType: 'sidebar',
    btnVariant: 'secondary',
    btnText: 'All Programs',
    analyticsTitle: 'qtf',
  },
  [AdminLocations.QTF.Activation]: {
    title: 'New Program',
    path: [
      AdminLocations.QTF.Programs,
      AdminLocations.QTF.Overview,
      AdminLocations.QTF.Activation,
    ],
    head: 'Tax Savings',
  },
  [AdminLocations.QTF.ActivationOnboarding]: {
    title: '',
    path: null,
    head: 'Tax Savings',
  },
  [AdminLocations.QTF.ActivationDefault]: {
    title: 'New Program',
    path: [AdminLocations.QTF.Programs, AdminLocations.QTF.ActivationDefault],
    head: 'Tax Savings',
  },
  [AdminLocations.QTF.Manage]: {
    title: 'Manage Program',
    path: [
      AdminLocations.QTF.Programs,
      AdminLocations.QTF.Overview,
      AdminLocations.QTF.Manage,
    ],
    head: 'Tax Savings',
  },

  //Micromobility
  [AdminLocations.Micromobility.Programs]: {
    title: 'Micromobility Programs',
    head: 'Micromobility',
    btnType: 'cta',
    btnVariant: 'primary',
    btnText: 'New Program',
    analyticsTitle: 'micromobility',
  },
  [AdminLocations.Micromobility.Overview]: {
    title: ':id',
    path: [
      AdminLocations.Micromobility.Programs,
      AdminLocations.Micromobility.Overview,
    ],
    hasDate: true,
    head: 'Micromobility',
    btnType: 'sidebar',
    btnVariant: 'secondary',
    btnText: 'All Programs',
    analyticsTitle: 'micromobility',
  },
  [AdminLocations.Micromobility.Activation]: {
    title: 'New Program',
    path: [
      AdminLocations.Micromobility.Programs,
      AdminLocations.Micromobility.Overview,
      AdminLocations.Micromobility.Activation,
    ],
    head: 'Micromobility',
  },
  [AdminLocations.Micromobility.Manage]: {
    title: 'Manage Program',
    path: [
      AdminLocations.Micromobility.Programs,
      AdminLocations.Micromobility.Overview,
      AdminLocations.Micromobility.Manage,
    ],
    head: 'Micromobility',
  },

  //Incentives
  [AdminLocations.Incentives.Programs]: {
    title: 'Trips & Incentives',
    hasDate: false,
    head: 'Trips',
    btnType: 'cta',
    btnVariant: 'primary',
    btnText: 'New Incentives',
    analyticsTitle: 'incentives',
  },
  [AdminLocations.Incentives.Trips]: {
    title: ':id',
    path: [AdminLocations.Incentives.Programs, AdminLocations.Incentives.Trips],
    ignoreMaxWidth: true,
    head: 'Trips',
    btnType: 'sidebar',
    btnVariant: 'secondary',
    btnText: 'All Incentives',
    analyticsTitle: 'incentives',
    noPadding: true,
  },
  [AdminLocations.Incentives.Activation]: {
    title: 'New Incentives',
    path: [
      AdminLocations.Incentives.Programs,
      AdminLocations.Incentives.Trips,
      AdminLocations.Incentives.Activation,
    ],
    head: 'Trips',
  },
  [AdminLocations.Incentives.Manage]: {
    title: 'Manage Incentives',
    path: [
      AdminLocations.Incentives.Programs,
      AdminLocations.Incentives.Trips,
      AdminLocations.Incentives.Manage,
    ],
    head: 'Trips',
  },
  [AdminLocations.Incentives.OTRHistory]: {
    title: 'OTR History',
    path: [
      AdminLocations.Incentives.Programs,
      AdminLocations.Incentives.Trips,
      AdminLocations.Incentives.OTRHistory,
    ],
    head: 'Trips',
  },

  // Opt-In
  [AdminLocations.OptIn.Programs]: {
    title: 'Opt-In',
    hasDate: false,
    head: 'Opt-In',
    // btnType: 'cta',
    // btnVariant: 'primary',
    // btnText: 'New Opt-In',
    analyticsTitle: 'optin',
  },
  [AdminLocations.OptIn.Overview]: {
    title: ':id',
    path: [AdminLocations.OptIn.Programs, AdminLocations.OptIn.Overview],
    hasDate: false,
    head: 'Opt-In',
    // btnType: 'sidebar',
    // btnVariant: 'secondary',
    // btnText: 'All Programs',
    analyticsTitle: 'optin',
  },
  [AdminLocations.OptIn.QuestionOverview]: {
    title: ':questionId',
    path: [
      AdminLocations.OptIn.Programs,
      AdminLocations.OptIn.Overview,
      AdminLocations.OptIn.QuestionOverview,
    ],
    hasDate: false,
    head: 'Opt-In',
    analyticsTitle: 'optin',
  },

  //OTR
  [AdminLocations.OTR.OTRHistory]: {
    title: 'One Time Rewards',
    head: 'One Time Rewards',
    analyticsTitle: 'one-time-rewards',
  },

  //Leaderboards
  [AdminLocations.Leaderboards.Programs]: {
    title: 'Leaderboards',
    btnType: 'cta',
    btnVariant: 'primary',
    btnText: 'New Competition',
    analyticsTitle: 'leaderboards',
  },
  [AdminLocations.Leaderboards.Leaderboards]: {
    title: ':id',
    head: 'Leaderboards',
    btnType: 'sidebar',
    btnVariant: 'secondary',
    btnText: 'All Leaderboards',
    analyticsTitle: 'leaderboards',
    path: [
      AdminLocations.Leaderboards.Programs,
      AdminLocations.Leaderboards.Leaderboards,
    ],
  },
  [AdminLocations.Leaderboards.Activation]: {
    title: 'Activate Competition',
    path: [
      AdminLocations.Leaderboards.Programs,
      AdminLocations.Leaderboards.Leaderboards,
      AdminLocations.Leaderboards.Activation,
    ],
    head: 'Leaderboards',
  },
  [AdminLocations.Leaderboards.Manage]: {
    title: 'Manage Competition',
    path: [
      AdminLocations.Leaderboards.Programs,
      AdminLocations.Leaderboards.Leaderboards,
      AdminLocations.Leaderboards.Manage,
    ],
    head: 'Leaderboards',
  },

  //Segments
  [AdminLocations.Segments.Overview]: {
    title: 'My Commuters',
    ignoreMaxWidth: true,
    noPadding: true,
  },
  [AdminLocations.Segments.UploadHistory]: {
    title: 'Upload History',
    path: [
      AdminLocations.Segments.Overview,
      AdminLocations.Segments.UploadHistory,
    ],
  },

  //Concierge
  [AdminLocations.Concierge.Concierge]: {
    title: 'Concierge',
    ignoreMaxWidth: true,
    noPadding: true,
  },
  [AdminLocations.Concierge.Announcement]: {
    title: 'Announcements',
    path: [
      AdminLocations.Concierge.Concierge,
      AdminLocations.Concierge.Announcement,
    ],
  },
  [AdminLocations.Concierge.Faq]: {
    title: 'Faqs',
    path: [AdminLocations.Concierge.Concierge, AdminLocations.Concierge.Faq],
  },
  //Accounts
  [AdminLocations.Accounts.Profile]: {
    title: 'Settings',
    ignoreMaxWidth: true,
    noPadding: true,
  },
  [AdminLocations.Accounts.Billing]: {
    title: 'Settings',
    ignoreMaxWidth: true,
    noPadding: true,
  },

  // Programs
  [AdminLocations.Programs.Overview]: {
    title: 'Programs',
    analyticsTitle: 'programs',
  },
  [AdminLocations.Programs.Launch]: {
    title: 'Build Your Commuter Program',
    analyticsTitle: 'launch-program',
  },
  [AdminLocations.Programs.Edit]: {
    title: 'Edit',
    path: [AdminLocations.Programs.Overview, AdminLocations.Programs.Edit],
    analyticsTitle: 'edit-program',
  },
  [AdminLocations.Programs.Success]: {
    title: 'Your Commute Program',
    analyticsTitle: 'launch-program-success',
  },

  // Reimbursement Submissions
  [AdminLocations.ReimbursementSubmissions]: {
    title: 'Reimbursement Submissions',
    analyticsTitle: 'reimbursement-submissions',
  },
  [AdminLocations.ReimbursementDetails]: {
    title: 'Request Details',
    path: [
      AdminLocations.ReimbursementSubmissions,
      AdminLocations.ReimbursementDetails,
    ],
    analyticsTitle: 'reimbursement-details',
  },
}
